import React from "react";
import { connect } from "react-redux";
import {
  Flex,
  SelectInput,
  SVGButton,
  TextInput,
  AreaInput,
  NumberInput,
} from "/app/src/component";
import DiscountModel from "/app/src/model/DiscountCode/model";
import DiscountSelector from "/app/src/model/DiscountCode/selector";

class Discount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      description: "",
      type: "discount_percentage",
      specification: "",
      startDateYear: 2019,
      startDateMonth: 1,
      startDateDay: 1,
      expiryDateYear: 2019,
      expiryDateMonth: 12,
      expiryDateDay: 1,
      numberOfUses: 1,
    };
  }
  componentDidMount() {
    this.props.dispatch(DiscountModel.get());
  }
  renderOverview() {
    console.log(this.props.discounts);
    return (
      <Flex w="50%" column>
        {this.props.discounts.map((d) => {
          return (
            <Flex key={d.id} column borderBottom="1px solid" color="grey">
              <Flex mb="5px" fontSize="20px">
                Namn: {d.code}
              </Flex>
              <Flex mb="5px" fontSize="20px">
                Type: {d.type}
              </Flex>
              {d.type === "PERCENTAGE_DISCOUNT" && (
                <Flex mb="5px" fontSize="20px">
                  Spec: {d.specification} %{" "}
                </Flex>
              )}

              {d.type === "EXTEND_TRIAL" && (
                <Flex mb="5px" fontSize="20px">
                  Spec: {d.specification} dagar{" "}
                </Flex>
              )}

              <Flex mb="5px" fontSize="20px">
                Beskrivning: {d.description}
              </Flex>
              <Flex mb="5px" fontSize="20px">
                Start Datum: {d.start_date}
              </Flex>
              <Flex mb="5px" fontSize="20px">
                Utång Datum: {d.expiry_date}
              </Flex>
              <Flex mb="5px" fontSize="20px">
                Antal användningar: {d.number_of_uses} ggr
              </Flex>
              <Flex mb="5px" fontSize="20px">
                Har använts: {d.used} ggr
              </Flex>
            </Flex>
          );
        })}
      </Flex>
    );
  }

  renderCreateNewCode() {
    function isValidDate(year, month, day) {
      var d = new Date(year, month, day);
      if (
        d.getFullYear() == year &&
        d.getMonth() == month &&
        d.getDate() == day
      ) {
        return true;
      }
      return false;
    }

    const CreateButton = {
      text: "Skapa",
      border: true,
      padding: "5px",
      margin: "5px",
      width: "200px",
      onClick: () => {
        this.props.dispatch(
          DiscountModel.create(
            this.state.name,
            this.state.description,
            this.state.type,
            this.state.specification,
            String(this.state.startDateYear) +
              "-" +
              String(this.state.startDateMonth) +
              "-" +
              String(this.state.startDateDay),
            String(this.state.expiryDateYear) +
              "-" +
              String(this.state.expiryDateMonth) +
              "-" +
              String(this.state.expiryDateDay),
            this.state.numberOfUses
          )
        );
      },
    };
    return (
      <Flex column w="50%">
        <Flex fontSize="32px" mb="10px">
          Create new code
        </Flex>
        <Flex mb="5px" fontSize="20px">
          Namn
        </Flex>
        <TextInput
          mb="10px"
          w="200px"
          onChange={(e) => {
            this.setState({ name: e.target.value });
          }}
          value={this.state.name}
        />

        <Flex fontSize="20px" mb="5px">
          Beskrivning av koden
        </Flex>
        <AreaInput
          w="200px"
          name="description"
          mb="10px"
          onChange={(e) => {
            this.setState({ description: e.target.value });
          }}
          value={this.state.description}
        />

        <Flex fontSize="20px" mb="5px">
          Typ av koden (percent eller utökad av trial)
        </Flex>
        <SelectInput
          w="200px"
          mb="10px"
          fontSize="15px"
          values={{
            discount_percentage: "Rabatt på nästa faktura",
            extend_trial: "öka trial dagar",
          }}
          onChange={(e) => {
            this.setState({ type: e.target.value });
          }}
          value={this.state.type}
        />

        {this.state.type === "discount_percentage" && (
          <Flex fontSize="20px" mb="5px">
            Discount Percentage, example: 0.25{" "}
          </Flex>
        )}
        {this.state.type === "extend_trial" && (
          <Flex fontSize="20px" mb="5px">
            Number of trial days extended, example: 14
          </Flex>
        )}
        <TextInput
          mb="10px"
          w="200px"
          onChange={(e) => {
            this.setState({ specification: e.target.value });
          }}
          value={this.state.specification}
        />

        <Flex fontSize="20px" mb="5px">
          Start Datum, yyyy-mm-dd
        </Flex>
        <Flex mb="10px" fontSize="20px">
          <NumberInput
            w="100px"
            fontSize="20px"
            onChange={(e) => {
              this.setState({ startDateYear: e.target.value });
            }}
            value={this.state.startDateYear}
          />
          -
          <NumberInput
            w="100px"
            onChange={(e) => {
              this.setState({ startDateMonth: e.target.value });
            }}
            value={this.state.startDateMonth}
          />
          -
          <NumberInput
            w="100px"
            onChange={(e) => {
              this.setState({ startDateDay: e.target.value });
            }}
            value={this.state.startDateDay}
          />
        </Flex>

        <Flex fontSize="20px" mb="5px">
          Utgång Datum, yyyy-mm-dd
        </Flex>
        <Flex mb="10px" fontSize="20px">
          <NumberInput
            w="100px"
            fontSize="20px"
            onChange={(e) => {
              this.setState({ expiryDateYear: e.target.value });
            }}
            value={this.state.expiryDateYear}
          />
          -
          <NumberInput
            w="100px"
            onChange={(e) => {
              this.setState({ expiryDateMonth: e.target.value });
            }}
            value={this.state.expiryDateMonth}
          />
          -
          <NumberInput
            w="100px"
            onChange={(e) => {
              this.setState({ expiryDateDay: e.target.value });
            }}
            value={this.state.expiryDateDay}
          />
        </Flex>

        <Flex fontSize="20px" mb="5px">
          Antal användningar
        </Flex>
        <NumberInput
          w="200px"
          mb="20px"
          onChange={(e) => {
            this.setState({ numberOfUses: e.target.value });
          }}
          value={this.state.numberOfUses}
        />
        <SVGButton {...CreateButton} />
      </Flex>
    );
  }
  render() {
    return (
      <Flex grow width="100%" h="100%">
        {this.renderOverview()}
        {this.renderCreateNewCode()}
      </Flex>
    );
  }
}
export default connect((state) => {
  return {
    discounts: DiscountSelector.get(state).toJS(),
  };
})(Discount);



// WEBPACK FOOTER //
// src/layout/Dashboard/MainPanel/Discount/index.js